module.exports = __webpack_public_path__ + "static/media/offices_Mid_ulster.bb192479.jpg";